var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIconUserManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_4238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.973 6.57043C11.7465 6.57043 11.5628 6.75408 11.5628 6.9806V12.9964C11.5628 13.3734 11.2562 13.68 10.8792 13.68H2.12895C1.75201 13.68 1.44534 13.3734 1.44534 12.9964V4.24614C1.44534 3.8692 1.75201 3.56253 2.12895 3.56253H8.14477C8.37129 3.56253 8.55493 3.37888 8.55493 3.15236C8.55493 2.92583 8.37129 2.74219 8.14477 2.74219H2.12895C1.29967 2.74219 0.625 3.41686 0.625 4.24614V12.9964C0.625 13.8257 1.29967 14.5004 2.12895 14.5004H10.8792C11.7085 14.5004 12.3832 13.8257 12.3832 12.9964V6.9806C12.3832 6.75408 12.1995 6.57043 11.973 6.57043Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3446 1.5533L13.5712 0.779858C13.198 0.406714 12.5909 0.406714 12.2177 0.779858L6.03033 6.96723C5.97307 7.02449 5.93405 7.09742 5.91814 7.17683L5.5314 9.11039C5.50452 9.24487 5.54661 9.38389 5.6436 9.48086C5.72128 9.55854 5.82593 9.60101 5.93361 9.60101C5.96038 9.60101 5.98729 9.59838 6.01403 9.59305L7.9476 9.20632C8.02701 9.19043 8.09994 9.15138 8.1572 9.09412L14.3446 2.90678C14.3446 2.90678 14.3446 2.90678 14.3446 2.90675C14.7177 2.53363 14.7177 1.92647 14.3446 1.5533ZM7.66496 8.42626L6.4565 8.66798L6.69822 7.45952L11.7343 2.42338L12.7011 3.39017L7.66496 8.42626ZM13.7645 2.32672L13.2811 2.81011L12.3143 1.84332L12.7977 1.35995C12.851 1.30662 12.9378 1.3066 12.9911 1.35992L13.7645 2.13336C13.8179 2.18666 13.8179 2.27342 13.7645 2.32672Z",
    fill: "#1D4469"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_4238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.625 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconUserManagement);
export default __webpack_public_path__ + "static/media/EditIconUserManagement.b9e581dd6311c9737aa3b27f9702467c.svg";
export { ForwardRef as ReactComponent };